import { CardContent, Grid, Divider } from '@mui/material';
import PageLoader from '../../../Components/Spinner/PageLoader';
import ModalsWrapper from '../../../Components/Modals/ModalsWrapper';
import PdfAndImageView from '../../../Components/pdfAndImageView/PdfAndImageView';
import { useState } from 'react';
import { CommonTypoGraphy } from '../../../Components/pdfAndImageView/CommonTypoGraphy';
import { ICompanyDocTradeCivil } from '../../../rest/types';
import CommonDetailItem, {
  formatDate,
  formatValue,
} from '../../../Components/CommonDetailItem/CommonDetailItem';

type IProps = {
  data: ICompanyDocTradeCivil;
  loading: boolean;
};

const CardCompanyDocument = ({ data: item, loading }: IProps) => {
  const [open, setOpen] = useState<boolean>(false);
  const [imageFile, setImageFile] = useState<string | null>('');

  return (
    <>
      {!loading ? (
        <CardContent>
          {/* Company Docs */}
          <Grid container pt={2} spacing={2}>
            <CommonDetailItem
              label='Ownership status'
              value={formatValue(item?.companyDocs?.company_ownership_status)}
            />
            <CommonDetailItem
              label='Office agreement'
              value={formatValue(item?.companyDocs?.company_office_agreement)}
            />
            <CommonDetailItem
              label='Agreement file'
              value={
                item?.companyDocs?.company_agreement_file ? (
                  <CommonTypoGraphy
                    name='View agreement file'
                    onClick={() => {
                      setOpen(true);
                      setImageFile(item?.companyDocs?.company_agreement_file);
                    }}
                  />
                ) : (
                  'N/A'
                )
              }
            />
            <CommonDetailItem
              label='Staff list'
              value={
                item?.companyDocs?.company_staff_list_file ? (
                  <CommonTypoGraphy
                    name='View staff list'
                    onClick={() => {
                      setOpen(true);
                      setImageFile(item?.companyDocs?.company_staff_list_file);
                    }}
                  />
                ) : (
                  'N/A'
                )
              }
            />
            <CommonDetailItem
              label='Sales statement'
              value={
                item?.companyDocs?.company_sales_statement ? (
                  <CommonTypoGraphy
                    name='View sales statement'
                    onClick={() => {
                      setOpen(true);
                      setImageFile(item?.companyDocs?.company_sales_statement);
                    }}
                  />
                ) : (
                  'N/A'
                )
              }
            />
            <CommonDetailItem
              label='Bank statement'
              value={
                item?.companyDocs?.company_bank_statement ? (
                  <CommonTypoGraphy
                    name='View bank statement'
                    onClick={() => {
                      setOpen(true);
                      setImageFile(item?.companyDocs?.company_bank_statement);
                    }}
                  />
                ) : (
                  'N/A'
                )
              }
            />
            {item?.companyDocs?.company_partnership_deed_file && (
              <CommonDetailItem
                label='Partnership deed'
                value={
                  <CommonTypoGraphy
                    name='View partnership deed'
                    onClick={() => {
                      setOpen(true);
                      setImageFile(
                        item?.companyDocs?.company_partnership_deed_file,
                      );
                    }}
                  />
                }
              />
            )}
            {item?.companyDocs?.company_incorporation_certificate && (
              <CommonDetailItem
                label='Incorporation cert'
                value={
                  <CommonTypoGraphy
                    name='View incorporation certificate'
                    onClick={() => {
                      setOpen(true);
                      setImageFile(
                        item?.companyDocs?.company_incorporation_certificate,
                      );
                    }}
                  />
                }
              />
            )}
            {item?.companyDocs?.company_memorandum_file && (
              <CommonDetailItem
                label='Memorandum'
                value={
                  <CommonTypoGraphy
                    name='View memorandum'
                    onClick={() => {
                      setOpen(true);
                      setImageFile(item?.companyDocs?.company_memorandum_file);
                    }}
                  />
                }
              />
            )}
            {item?.companyDocs?.company_one_staff_certificate && (
              <CommonDetailItem
                label='Staff GDS cert'
                value={
                  <CommonTypoGraphy
                    name='View staff GDS certificate'
                    onClick={() => {
                      setOpen(true);
                      setImageFile(
                        item?.companyDocs?.company_one_staff_certificate,
                      );
                    }}
                  />
                }
              />
            )}
            {item?.companyDocs?.company_office_photographs?.length > 0 &&
              item?.companyDocs?.company_office_photographs?.map((file, i) => (
                <CommonDetailItem
                  key={file}
                  label={`Office photo ${i + 1}`}
                  value={
                    <CommonTypoGraphy
                      name={`${i + 1}. Office photograph`}
                      onClick={() => {
                        setOpen(true);
                        setImageFile(file);
                      }}
                    />
                  }
                />
              ))}
            <CommonDetailItem
              label='Undertaking file'
              value={
                item?.companyDocs?.company_undertaking_file ? (
                  <CommonTypoGraphy
                    name='View Undertaking File'
                    onClick={() => {
                      setOpen(true);
                      setImageFile(item?.companyDocs?.company_undertaking_file);
                    }}
                  />
                ) : (
                  'N/A'
                )
              }
            />
          </Grid>

          <Divider sx={{ my: 3 }} />

          {/* Trade License / Tax / BIN */}
          <Grid container spacing={2}>
            <CommonDetailItem
              label='Trade license'
              value={formatValue(item?.companyLicense?.company_trade_license)}
            />
            <CommonDetailItem
              label='Trade license file'
              value={
                item?.companyLicense?.company_trade_license_file ? (
                  <CommonTypoGraphy
                    name='View trade license'
                    onClick={() => {
                      setOpen(true);
                      setImageFile(
                        item?.companyLicense?.company_trade_license_file,
                      );
                    }}
                  />
                ) : (
                  'N/A'
                )
              }
            />
            <CommonDetailItem
              label='Trade license expiry'
              value={formatDate(
                item?.companyLicense?.company_trade_license_expiry_date,
                'Do-MM-YYYY',
              )}
            />
            {item?.companyLicense?.company_tin_number && (
              <CommonDetailItem
                label='TIN number'
                value={formatValue(item?.companyLicense?.company_tin_number)}
              />
            )}
            {item?.companyLicense?.company_tin_file && (
              <CommonDetailItem
                label='Tax return proof'
                value={
                  <CommonTypoGraphy
                    name='View Proof of Submission of Tax Return'
                    onClick={() => {
                      setOpen(true);
                      setImageFile(item?.companyLicense?.company_tin_file);
                    }}
                  />
                }
              />
            )}
            {item?.companyLicense?.company_bin_number && (
              <CommonDetailItem
                label='BIN number'
                value={formatValue(item?.companyLicense?.company_bin_number)}
              />
            )}
            {item?.companyLicense?.company_bin_file && (
              <CommonDetailItem
                label='BIN file'
                value={
                  <CommonTypoGraphy
                    name='View BIN file'
                    onClick={() => {
                      setOpen(true);
                      setImageFile(item?.companyLicense?.company_bin_file);
                    }}
                  />
                }
              />
            )}
          </Grid>

          <Divider sx={{ my: 3 }} />

          {/* Civil Aviation */}
          <Grid container spacing={2}>
            <CommonDetailItem
              label='Certificate number'
              value={formatValue(
                item?.companyCivilAviation?.certificate_number,
              )}
            />
            <CommonDetailItem
              label='Certificate file'
              value={
                item?.companyCivilAviation?.certificate_file ? (
                  <CommonTypoGraphy
                    name='View certificate'
                    onClick={() => {
                      setOpen(true);
                      setImageFile(
                        item?.companyCivilAviation?.certificate_file,
                      );
                    }}
                  />
                ) : (
                  'N/A'
                )
              }
            />
            <CommonDetailItem
              label='Certificate issue date'
              value={formatDate(
                item?.companyCivilAviation?.certificate_issue_date,
              )}
            />
            <CommonDetailItem
              label='Certificate expiry date'
              value={formatDate(
                item?.companyCivilAviation?.certificate_expiry_date,
              )}
            />
          </Grid>
        </CardContent>
      ) : (
        <PageLoader />
      )}
      <>
        <ModalsWrapper
          modalData={{ title: 'View document' }}
          setShowModal={setOpen}
          showModal={open}
        >
          <PdfAndImageView file={imageFile} />
        </ModalsWrapper>
      </>
    </>
  );
};

export default CardCompanyDocument;
